<template>
  <component
    :is="component"
    :to="to"
    class="button-recommendation"
    @click="handleClick"
  >
    <span class="icon"><slot name="icon" /></span>

    <slot class="content" />

    <span class="arrow-container">
      <icon class="arrow" name="nextSmall" size="1.2rem" />
      <icon class="arrow over" name="nextSmall" size="1.2rem" />
    </span>
  </component>
</template>
<script setup lang="ts">
import type { NuxtLinkProps } from '#app';
import type { RouteLocationRaw } from 'vue-router';
interface Props extends NuxtLinkProps {
  recommendation?: BaseRecommendationSchema;
  to?: RouteLocationRaw;
}

const props = defineProps({
  recommendation: null,
  to: null
});

const dialogLockedContent = useDialogLockedContent();

const profile = useProfileStore();

const component = computed(() => {
  if (profile.isASubscriber) {
    return resolveComponent('NuxtLink');
  }
  return 'button';
});

const handleClick = () => {
  if (!profile.isASubscriber) {
    dialogLockedContent.open(
      props?.recommendation?.itemsType || 'mixed',
      null,
      null,
      props?.recommendation
        ? useAppEventShare(
            EventAssociatedModel.ContentLockScreen,
            props.recommendation.id,
            props.recommendation.itemsType
          )
        : null
    );
  }
};
</script>
<style lang="scss" scoped>
.button-recommendation {
  display: grid;
  position: relative;
  grid-template-columns: 3.5rem 1fr auto;
  flex-direction: column;
  align-items: center;
  width: 22.4rem;
  height: 8.6rem;
  padding: var(--gap_n);
  gap: var(--gap_xs);
  overflow: hidden;
  color: var(--color_neutral_25);

  > * {
    z-index: 1;
  }
  &::after,
  &::before {
    content: '';
    display: block;
    position: absolute;
    z-index: 0;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
    transform: scale(0.99, 0.96);
    transition: transform 400ms $ease-out-back,
      background-color 400ms $ease-out-quad;
    border-color: rgb(231 227 255 / 20%);

    @include stroke('n', 'm');
  }
  &::before {
    transform: scale(0.99, 0.96);
    transition: transform 400ms $ease-out-quad, opacity 200ms $ease-in-quad;
    border-color: transparent;
    opacity: 0;
    background-color: var(--color_secondary_dark);
  }
  &::after {
    transition: transform 400ms $ease-out-back,
      background-color 200ms $ease-out-quad 400ms;
    border-color: rgb(231 227 255 / 20%);
    background-color: transparent;
  }

  @include hover-focus-desktop {
    &::after {
      transform: scale(1);
      border-color: rgb(231 227 255 / 50%);
    }
    &::before {
      transform: scale(1);
      opacity: 1;
    }
    .icon {
      transform: scale(1);
    }
    .arrow {
      transform: translateX(2.2rem);
      transition: transform 200ms $ease-in-back;

      &.over {
        transform: translateX(2.2rem);
        transition: transform 200ms $ease-out-back 100ms;
      }
    }
  }
}

.icon {
  flex: 0 0 auto;
  transform: scale(0.93);
  transition: transform 300ms $ease-in-out-back;
  :deep(img) {
    width: 3.5rem;
    height: auto;
  }
}

.arrow-container {
  display: flex;
  position: relative;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  width: 2.2rem;
  height: 2.2rem;
  overflow: hidden;
}
.arrow {
  position: relative;
  z-index: 1;
  color: var(--color_secondary_darker);
  color: var(--color_secondary);
  &.over {
    position: absolute;
    top: calc(0.5 * (2.2rem - 1.2rem));
    left: calc(0.5 * (2.2rem - 1.2rem) - 2.2rem);
    color: var(--color_neutral_25);
  }
}
</style>
